<template>
  <div class="collect_wrap">
    <div class="collect_top">
      <div :class="actionType == 1 ? 'video-search' : ''">
        <el-input placeholder="请输入名称" prefix-icon="el-icon-search" v-model="searchForm.devicesName" clearable>
        </el-input>
      </div>
    </div>
    <div class="collect_container">
      <el-scrollbar ref="scrollBar" class="scroll-bar">
        <el-tree class="deviceTree" ref="collectTree" :data="cameraTree" node-key="id" :props="defaultProps"
          :show-checkbox="multiCheck" highlight-current :default-expanded-keys="expandedKeys"
          :default-checked-keys="defaultCheckedKeys" :filter-node-method="filterNode" @node-click="getCheckNode"
          @check="handleCheckNode">
          <div class="node" :title="data.id" slot-scope="{ data }" :class="[
            {
              'out-line': parseInt(data.status) !== 1 && data.nodeType === 'device',
            },
            data.color,
            data.nodeType == 'device' ? 'showDrag' : '',
          ]" @dblclick="() => {
    data.id != -1 && deviceChoose(data);
  }
  ">
            <div style="display: flex; align-items: center">
              <img class="area-node-icon" v-if="data.nodeType === 'file'" src="@src/common/assets/images/文件夹.png"
                alt="" />
              <i v-if="data.nodeType === 'device'" :style="{ color: data.color }"
                class="iconfont-lunan icon-lunan-shexiangtou"></i>
              <span class="node-label" :class="data.nodeType === 'file' ? 'file-label' : ''">{{ data.name }}</span>
              <span title="播放中" v-if="liveDeviceIds.includes(data.thirdCameraId)" class="node-state-live">
                <img src="@src/common/assets/images/直播中.png" alt="" />
              </span>
              <span title="回放中" v-if="backDeviceIds.includes(data.thirdCameraId)" class="node-state-back">
                <img src="@src/common/assets/images/视频回放.png" alt="" />
              </span>
            </div>

            <!-- 节点选中后的操作按钮 -->
            <div v-if="(data.id == -1 ||
                (checkNode.id == data.id && checkNode.parentId == data.parentId)) &&
              actionType == 1
              " :class="[
    data.id == -1 ? 'show' : data.nodeType == 'device' ? 'showDevice' : '',
    'tree-operator',
  ]">
              <el-button v-if="data.id == -1" type="text" size="medium" title="新建文件夹" @click.stop="handleAddFile"
                style="font-size: 18px" class="el-icon-circle-plus-outline"></el-button>
              <el-button v-if="data.id != -1 && data.nodeType === 'file'" type="text" size="medium"
                class="el-icon-edit-outline" @click.stop="() => handleEditFile(data)"></el-button>
              <el-button v-if="data.id != -1 && data.nodeType === 'file'" type="text" size="medium"
                class="el-icon-delete-solid" @click.stop="() => handleDelFile(data)"></el-button>
              <el-button v-if="data.nodeType === 'device'" type="text" size="medium" title="移除该文件夹"
                style="font-size: 16px" class="el-icon-remove-outline"
                @click.stop="() => handleDelDevice(data)"></el-button>
            </div>
            <div v-if="(data.id == -1 || checkNode.id == data.id) && actionType == 2" :class="['show', 'tree-operator']">
              <el-button v-if="data.id == -1" type="text" size="medium" title="新建文件夹" @click.stop="handleAddFile"
                style="font-size: 18px" class="el-icon-circle-plus-outline"></el-button>
              <el-button v-if="data.id != -1 && data.nodeType === 'file'" type="text" size="medium" title="收藏至该文件夹"
                style="font-size: 17px" class="el-icon-star-on" @click.stop="() => handleCollectDevice(data)"></el-button>
            </div>
          </div>
        </el-tree>
      </el-scrollbar>
    </div>
    <!-- 新增文件架 -->
    <el-dialog :title="state === 1 ? '新增文件夹' : '修改文件夹'" v-ops:width="480" :append-to-body="true" :visible.sync="formShow"
      @close="handleCloseForm" :close-on-click-modal="false">
      <ioc-forms :option="formOption" :formData="formData" ref="form"></ioc-forms>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseForm"> 取消 </el-button>
        <el-button type="primary" @click="handleSaveForm"> 保存 </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { api } from "../api.js";
import busVue from "@/common/utils/busVue";
export default {
  props: {
    multiCheck: {
      type: Boolean,
      default: false,
    },
    // 操作模式，1 收藏，2 添加
    actionType: {
      type: Number,
      default: 1,
    },
    // 要收藏的设备list
    collectDevice: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  watch: {
    actionType: {
      handler(val) {
        if (val == 2) {
          this.queryFileList();
        }
      },
      immediate: true,
    },
    "searchForm.devicesName": {
      handler(val) {
        this.$refs.collectTree.filter(val);
      },
    },
  },

  data() {
    return {
      state: 1,
      formShow: false,
      formOption: {
        labelWidth: 100,
        emptyBtn: false,
        submitBtn: false,
        column: [
          {
            label: "文件夹名称",
            span: 24,
            prop: "name",
            rules: [
              {
                required: true,
                message: "请输入文件夹名称",
                trigger: "change",
              },
            ],
          },
        ],
      },
      defaultCheckedKeys: [],
      formData: {
        name: "",
        folderCode: "",
      },
      searchForm: {
        devicesName: "",
      },
      cameraTree: [
        {
          name: "收藏夹",
          id: "-1",
          nodeType: "file",
          children: [],
        },
      ],
      defaultProps: {
        children: "children",
        label: "name",
        id: "id",
      },
      checkedDevice: [], //选中的设备
      checkedArea: [], //选中的区域
      expandedKeys: [], // 默认展开的数组
      showTree: true,
      deviceName: "",
      thirdCameraId: "",
      clickNum: 0,
      liveDeviceIds: [],
      backDeviceIds: [],
      checkNode: {},
    };
  },
  created() {
    busVue.$on("handlePlayLiveCallBack", (info) => {
      if (info.state == 1) {
        info.videoType == "live"
          ? this.liveDeviceIds.push(info.thirdCameraId)
          : this.backDeviceIds.push(info.thirdCameraId);
      } else {
        if (info.videoType == "live") {
          let index = this.liveDeviceIds.indexOf(info.thirdCameraId);
          this.liveDeviceIds.splice(index, 1);
        } else {
          let index = this.backDeviceIds.indexOf(info.thirdCameraId);
          this.backDeviceIds.splice(index, 1);
        }
      }
    });
  },
  beforeDestroy() {
    busVue.$off("handlePlayLiveCallBack");
  },
  mounted() {
    this.queryFileList();
  },
  methods: {
    //重置tree选中
    resetSelect() {
      this.$refs.collectTree.setCheckedKeys([]);
      this.checkedDevice = [];
    },
    // 查询文件夹
    queryFileList() {
      this.$fetch(api.queryFolderList).then((response) => {
        this.cameraTree[0].children = [];
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        } else {
          let result = response.returnObj;
          if (response.returnObj.length > 0) {
            this.expandedKeys = [result[0].id]; //默认展开第一级
            this.cameraTree[0].children = result;
          }
        }
      });
    },
    filterNode(value, data) {
      if (!value) {
        return true;
      }
      return data.name.indexOf(value) !== -1;
    },
    showRedIcon(data, bfdata) {
      // console.log(bfdata, "=====bfsata");
      let redData = bfdata;
      const self = this;
      if (data !== null) {
        data.forEach((item) => {
          if (item.nodeType == "device") {
            let nameCopy = item.name;
            item.name = "";
            let isHave = redData.some((el) => {
              return el.deviceId == item.thirdCameraId;
            });
            // this.$nextTick(() => {
            item.name = nameCopy;
            !isHave ? delete item.color : (item.color = "showIcon");
            // })
          }
          if (item.children) {
            self.showRedIcon(item.children, redData);
          }
          return;
        });
      }
    },
    showIcon(data) {
      console.log(data);
      var nodes = this.cameraTree[0].children;
      this.showRedIcon(nodes, data);
    },
    cameraIcon(data) {
      switch (data.ability) {
        case "0":
          return "";
        case "1":
          return "icon-lunan-renyuanbukong";
        case "2":
          return "icon-lunan-cheliangbukong";
        // case '3':return 'icon iconfont icon-b_icon__cam_hem';
        default:
          return "";
      }
    },
    handleAddFile() {
      this.state = 1;
      this.formShow = true;
    },
    // 新增修改弹窗 关闭清除数据
    handleCloseForm() {
      this.formShow = false;
      this.$refs["form"].$refs["form"].resetFields();
    },
    // 添加该文件夹
    handleCollectDevice(info) {
      console.log(info);
      this.$confirm("您确定将摄像机收藏至该文件夹?", "添加确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let monitorPointsInfo = this.collectDevice.map((item) => {
            return {
              monitorPointCode: item.id, // 监控点编号
              monitorPointThirdCode: item.thirdCameraId, // 监控点第三方编号
              monitorPointName: item.name, // 监控点名称
              monitorPointType: item.cameraType, // 监控点类型
            };
          });
          let MonitorPointsVo = {
            folderCode: info.id, // 文件夹编号
            originalMonitorPointCode: "", // 监控点所属原文件夹编号
            monitorPointsInfo,
          };
          this.$fetch(api.setMonitorPoints, MonitorPointsVo).then((response) => {
            if (!response.success) {
              this.$message.error(response.msgContent);
              return;
            } else {
              this.$message.success("添加成功");
              this.queryFileList();
              this.$emit("handleCollectUpdate");
            }
          });
        })
        .catch((err) => {
          //
        });
    },
    // 删除
    handleDelDevice(info) {
      this.$confirm("您确定将该摄像机从文件夹移除?", "移除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = [
            {
              id: info.id,
              nodeType: "device",
              parentId: info.parentId,
            },
          ];
          this.$fetch(api.deleteFolderOrMonitorPoint, params).then((response) => {
            if (!response.success) {
              this.$message.error(response.msgContent);
              return;
            } else {
              this.$message.success("清除成功");
              this.queryFileList();
            }
          });
        })
        .catch((err) => {
          //
        });
    },
    // 删除文件夹
    handleDelFile(info) {
      this.$confirm("您确定删除该文件夹及摄像机?", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = [
            {
              id: info.id,
              nodeType: "file",
              parentId: "-1",
            },
          ];
          this.$fetch(api.deleteFolderOrMonitorPoint, params).then((response) => {
            if (!response.success) {
              this.$message.error(response.msgContent);
              return;
            } else {
              this.$message.success("删除成功");
              this.queryFileList();
            }
          });
        })
        .catch((err) => {
          //
        });
    },
    // 修改
    handleEditFile(info) {
      this.formShow = true;
      this.state = 2;
      this.formData.name = info.name;
      this.formData.folderCode = info.id;
    },
    // 新增/修改
    handleSaveForm() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let url = this.state === 1 ? api.addFolder : api.updateFolder;
          let params = {};
          if (this.state === 1) {
            params = {
              folderName: this.formData.name,
              superFolderCode: -1,
            };
          } else {
            params = {
              folderName: this.formData.name,
              folderCode: this.formData.folderCode,
            };
          }
          this.$fetch(url, params).then((res) => {
            if (res.success) {
              this.$message({
                message: this.state === 1 ? "新增成功" : "修改成功",
                type: "success",
                duration: 2000,
              });
              this.formShow = false;
              this.queryFileList();
            } else {
              this.$message.error(res.msgContent);
            }
          });
        } else {
          return false;
        }
      });
    },
    // 双击
    deviceChoose(nodeData) {
      if (nodeData.nodeType == "device") {
        if (nodeData.status != 1) {
          this.$message.warning(this.$t("business.message.offline"));
          return;
        }
        busVue.$emit("handleChooseCamera", nodeData);
      } else {
        // 双击批量播放
        let playBatch = nodeData.children;
        busVue.$emit("handleChooseCamera", playBatch, "batch");
      }
    },
    // 单击
    getCheckNode(nodeData) {
      this.checkNode = { ...nodeData };
    },
    // tree多选
    handleCheckNode(node, checkData) {
      let checkNodes = checkData.checkedNodes; // 当前被选中节点数组
      this.checkedArea = []; //选中的区域
      this.checkedDevice = []; //选中的设备
      checkNodes.forEach((item) => {
        if (item.nodeType == "device") {
          this.checkedDevice.push(item);
        } else {
          this.checkedArea.push(item);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";

.collect {
  &_wrap {
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
  }

  &_top {
    margin-bottom: 16px;

    .video-search {
      display: flex;
      margin-top: 16px;
    }

    .video-check {
      display: flex;
      justify-content: space-between;
      margin: 16px 0px;
      align-items: center;
    }
  }

  &_container {
    height: calc(100% - 60px);
    position: relative;

    .scroll-bar {
      height: 100%;
      padding-bottom: 10px;
    }

    .deviceTree {
      .node {
        display: flex;
        width: 100%;
        height: 32px;
        justify-content: space-between;
        align-items: center;

        .tree-operator {
          display: block;
          width: 50px !important;
          margin-left: 10px;
          height: 35px;

          .el-icon-circle-plus-outline {
            font-size: 16px;
          }

          .el-button {
            // color: #fff !important;
          }
        }

        .show {
          //   display: block !important;
          width: 25px !important;
        }

        .showDevice {
          width: 25px !important;
        }

        .node-label {
          display: inline-block;
          width: 135px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
        }

        .file-label {
          width: 165px;
        }

        .node-state {
          &-live {
            position: absolute;
            right: 28px;
          }

          &-back {
            position: absolute;
            right: 52px;
          }
        }

        &.out-line {
          color: #757373;

          .icon {
            color: #757373;
          }
        }

        .camera-type-icon {
          text-align: right;
          flex: 1;
          margin-right: 10px;
        }
      }
    }

    .showIcon {
      @include set_theme_color(color, main-theme-color);

      &:hover {
        color: #fff;
      }
    }

    .showDrag {
      max-width: 260px;
    }

    .area-node-icon {
      margin-right: 5px;
    }

    .iconfont-lunan {
      margin-right: 5px;
    }
  }
}

/deep/.el-tree-node__content {
  height: 32px;
}
</style>
